// extracted by mini-css-extract-plugin
export default {"logo":"logo_x_x","spacer":"logo_x_spacer"};